import {initReactI18next} from "react-i18next";
import i18next from "i18next";

import en from './en/translation.json'
import nl from './nl/translation.json'
import LanguageDetector from "i18next-browser-languagedetector";

i18next.use(LanguageDetector).use(initReactI18next).init({
    interpolation: { escapeValue: false },
    // fallbackLng: 'en',
    detection: {
        order: ['localStorage', 'navigator'], // Detect from localStorage first, then fallback to navigator language
        caches: ['localStorage'] // Cache the selected language in localStorage
    },
    resources: {
        en: {
            translation: en
        },
        nl: {
            translation: nl
        }
    }
})